import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { BlockList } from '@udemy-v2/react-core-components';
import { useI18n } from '@udemy-v2/i18n';
export interface CollapsiblePurchaseBoxContentProps {
  coursesCount: string;
  categoryName: string;
}
export function CollapsiblePurchaseBoxContent(collapsableProps) {
  const $ = _c(13);
  const {
    gettext,
    interpolate
  } = useI18n();
  let t0;
  if ($[0] !== collapsableProps.categoryName || $[1] !== collapsableProps.coursesCount || $[2] !== gettext || $[3] !== interpolate) {
    t0 = collapsableProps.categoryName && <BlockList.Item icon={<Icon label="" size="xsmall" glyph="video-playlist" />}><span className="ud-text-sm">{interpolate(gettext("Get this course and many more in %(category_name)s and access to %(courses_count)s+ courses"), {
          courses_count: collapsableProps.coursesCount,
          category_name: collapsableProps.categoryName
        }, true)}</span></BlockList.Item>;
    $[0] = collapsableProps.categoryName;
    $[1] = collapsableProps.coursesCount;
    $[2] = gettext;
    $[3] = interpolate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon label="" size="xsmall" glyph="list-alt" />;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== gettext) {
    t2 = gettext("AI, Development, Business, Design & 50+ topics");
    $[6] = gettext;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <BlockList.Item icon={t1}><span className="ud-text-sm">{t2}</span></BlockList.Item>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t0 || $[11] !== t3) {
    t4 = <div>{t0}{t3}</div>;
    $[10] = t0;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
export const SUBSCRIPTION_SUB_VALUE_PROP_MSG = '<span class="bold">Our subscribers don’t pay per course.</span> ' + 'In their first month, they take 9+ courses and save ₹4000+.';